if (!customElements.get('optimista-feed')) {
  customElements.define('optimista-feed', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('[data-feed-grid]');
      this.pager = this.querySelector('[data-feed-pager]');
      this.status = this.querySelector('[data-feed-status]');
      this.visited = new Set();
      this.busy = false;
      if (!this.grid || !this.pager) return;
      this.clickHandler = event => {
        const link = event.target.closest('[data-feed-next]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load(true);
      };
      this.pager.addEventListener('click', this.clickHandler);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load(false);
        }, { rootMargin: '0px 0px 180px 0px' });
        this.observeNext();
      }
    }
    observeNext() {
      this.observer?.unobserve(this.pager);
      if (this.querySelector('[data-feed-next]')) this.observer?.observe(this.pager);
    }
    async load(manual) {
      const link = this.pager.querySelector('[data-feed-next]');
      if (this.busy || !link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || this.visited.has(url.href)) return;
      const pageKey = url.href;
      url.searchParams.set('section_id', this.dataset.section);
      this.busy = true;
      this.grid.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');
      this.controller = new AbortController();
      try {
        const response = await fetch(url, { signal: this.controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Could not load this page');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = [...doc.querySelectorAll('optimista-feed')].find(node => node.dataset.feedKey === this.dataset.feedKey);
        if (!feed) throw new Error('Missing product grid');
        if (!this.isConnected) return;
        const seen = new Set([...this.grid.children].map(node => node.dataset.feedProduct));
        const items = [...feed.querySelector('[data-feed-grid]').children].filter(node => !seen.has(node.dataset.feedProduct));
        const fragment = document.createDocumentFragment();
        items.forEach(node => fragment.append(document.importNode(node, true)));
        const firstLink = fragment.querySelector('a');
        this.grid.append(fragment);
        this.pager.replaceChildren(...[...feed.querySelector('[data-feed-pager]').childNodes].map(node => document.importNode(node, true)));
        this.visited.add(pageKey);
        if (this.status) this.status.textContent = this.dataset.loadedText.replace('[count]', String(items.length));
        if (manual && firstLink) firstLink.focus({ preventScroll: false });
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.observer?.disconnect();
          if (this.status) this.status.textContent = this.dataset.errorText;
        }
      } finally {
        this.busy = false;
        this.grid.setAttribute('aria-busy', 'false');
        this.pager.querySelector('[data-feed-next]')?.removeAttribute('aria-disabled');
        if (this.isConnected && this.visited.has(pageKey)) this.observeNext();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.pager?.removeEventListener('click', this.clickHandler);
      this.ready = false;
    }
  });
}
